var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "video", "data-size": "2x1" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _c(
          "div",
          {
            staticClass: "go-card-video",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.viewDetail.apply(null, arguments)
              },
            },
          },
          [
            _c("img", {
              staticStyle: {
                "max-width": "100% !important",
                height: "100% !important",
              },
              attrs: {
                src: _vm.fetchYoutubeThumbnail(_vm.videoUrl, "low"),
                alt: "",
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-card-body" },
          [
            _c("div", { staticClass: "go-block-header" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px",
                  },
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("span", { staticClass: "go-channel" }, [
                    _vm._v(_vm._s(_vm.formModel.channel) + " "),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-body" }, [
              _c(
                "a",
                { staticClass: "go-card-title", on: { click: _vm.viewDetail } },
                [_vm._v(_vm._s(_vm.formModel.title))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-card-desc" }, [
                _vm._v(_vm._s(_vm.formModel.content)),
              ]),
            ]),
            _vm._v(" "),
            _c("resource-footer", {
              attrs: {
                "form-model": _vm.formModel,
                "is-hide-options": _vm.isHideOptions,
                "is-hide-add-reference": _vm.isHideAddReference,
                "is-hide-goover": _vm.isHideGoover,
                "is-hide-hidden": _vm.isHideHidden,
                "is-hide-shared": _vm.isHideShared,
              },
              on: {
                "add-to-reference": _vm.addToReference,
                hide: function ($event) {
                  $event.stopPropagation()
                  return _vm.hide.apply(null, arguments)
                },
                share: _vm.share,
                "select-user-social": _vm.selectUserSocial,
                "toggle-resource": _vm.toggleResource,
                goover: _vm.goover,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isContentNew
          ? _c("div", { staticClass: "go-card-new" }, [_vm._v("New")])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-video-overlay-play" }, [
      _c("div", { staticClass: "go-video-play" }, [
        _c("i", { staticClass: "go-icon-20 go-icon-player-play-filled" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { "margin-top": "-3px" } }, [
      _c("img", {
        attrs: {
          width: "16px",
          height: "16px",
          src: "/content/images/images_v4/sample/@sample-media-3.png",
          alt: "youtube",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }